import { css } from '@emotion/css'
import { spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'

const styles = {
  heading: css({
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: colors.athensGray,
    padding: shorthandHelper([spacing.small, spacing.default]),
  }),

  navigation: css({
    display: 'inline-flex',
    alignItems: 'center',
  }),
}

export default styles
